import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AngularMaterialModule } from './angular-material.module';

import { SkeletionLoaderComponent } from '../components/utility/skeletion-loader/skeletion-loader.component';
import { NoDataFoundComponent } from '../components/utility/no-data-found/no-data-found.component';
import { FetchingDataComponent } from '../components/utility/fetching-data/fetching-data.component';
import { ImageFallbackDirective } from '../directives/img-fallback.directive';
import { SafeHTMLPipe } from '../pipes/safe-html.pipe';
import { SafeEmailPipe } from '../pipes/safe-email.pipe';
import { SafeURLPipe } from '../pipes/safe-resource-url.pipe';
import { SwiperModule } from 'swiper/angular';
import { FilterByStatePipe } from '../pipes/filter-by-state.pipe';
import { LoaderComponent } from '../components/utility/loader/loader.component';
import { SafePipe } from '../pipes/safe.pipe';
import { ChartComponent } from '../components/utility/chart/chart.component';
import { AnimatingCountDirective } from '../directives/animating-count.directive';
import { ImageLazyLoadingDirective } from '../directives/img-lazy-loading.directive';
import { ArrowForwardSvgComponent } from '../components/layout/svg/arrow-forward-svg.component';

const components = [
  SkeletionLoaderComponent,
  NoDataFoundComponent,
  LoaderComponent,
  FetchingDataComponent,
  ChartComponent,
  AnimatingCountDirective,
];
const directives = [ImageFallbackDirective, ImageLazyLoadingDirective];
const pipes = [
  SafeHTMLPipe,
  SafeEmailPipe,
  SafeURLPipe,
  FilterByStatePipe,
  SafePipe,
];
const modules = [
  FormsModule,
  ReactiveFormsModule,
  AngularMaterialModule,
  TranslateModule,
  SwiperModule,
];

@NgModule({
  declarations: [...components, ...directives, ...pipes],
  imports: [CommonModule, ...modules, ArrowForwardSvgComponent],
  exports: [
    ...modules,
    ...components,
    ...directives,
    ...pipes,
    ArrowForwardSvgComponent,
  ],
})
export class SharedModule {
  constructor() {}
}
